// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36i6u","footer":"styles_footer__2hXs0"};